// extracted by mini-css-extract-plugin
export var cardIcon = "_as-4";
export var checkboxCard = "_as-0";
export var checkboxCardSelected = "_as-3";
export var disabled = "_as-1";
export var outerBorder = "_as-2";
export var spacerMedium = "_as-7";
export var spacerSmall = "_as-6";
export var spacerXsmall = "_as-5";